export const MAX_SIGNATURE_PNG_BYTES = 256 * 1024
export const MAX_SIGNATURES_PER_USER = 5

export function validateSignatureFile(file) {
  if (!file) {
    return { ok: false, message: 'Выберите PNG-файл' }
  }
  const type = String(file.type || '').toLowerCase()
  const name = String(file.name || '').toLowerCase()
  const looksPng = type === 'image/png' || name.endsWith('.png')
  if (!looksPng) {
    return { ok: false, message: 'Допустимы только файлы PNG' }
  }
  if (file.size > MAX_SIGNATURE_PNG_BYTES) {
    return {
      ok: false,
      message: `PNG не должен превышать ${MAX_SIGNATURE_PNG_BYTES / 1024} КБ`,
    }
  }
  return { ok: true, message: '' }
}
